export function getHtmlOffset(el) {
  let x = 0;
  let y = 0;
  while (el) {
    if (isNaN(el.offsetLeft) || isNaN(el.offsetTop)) {
      const elementRect = el.getBoundingClientRect();
      x += elementRect.left - el.scrollLeft;
      y += elementRect.top - el.scrollTop;
      el = undefined;
    } else {
      x += el.offsetLeft - el.scrollLeft;
      y += el.offsetTop - el.scrollTop;
      el = el.offsetParent;
    }
  }
  return { top: y, left: x };
}
